<!-- 学习效力 -->
<template>
    <div class="page_part3">
        <div class="page_shadow page_main">
            <!-- <div class="top_header">学习力测评报告</div>-->
            <TopHeader :title="'学习策略评估结果'" :headerLogo="headerLogo"></TopHeader>
            <h5 class="header page_header":style="{marginBottom: '20px'}">
                <span>Part.3 学习效力</span>
            </h5>
            <div class="header_detail_box" :style="{paddingBottom: '10px'}">
                <p class="header_detail">学习效力指的是如何有效地学习，主要由方法效力和风格效力组成。其中，方法效力指的是学习策略，风格效力指的是学习风格。</p>
            </div>
            <h6 class="page_title_2">
                <span>学习策略</span>
                <span class="arrow"></span>
            </h6>
            <div class="header_detail_box" :style="{paddingBottom: '10px'}">
                <p class="header_detail">学习策略指的是为了提高学习效率而制定的有关学习的复杂方案。它包括认知策略、元认知策略和资源管理策略。</p>
            </div>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习策略评估结果
            </p>

            <div class="main_box main_box_part3 part3_1_main_box"  :style="{marginBottom:'0px'}">
                <div class="main_norm_box" :style="{marginTop:'50px'}">
                    <div class="norm_box" :style="{width: total.score/200*692  + 'px'}" >
                        <div class="norm_score">
                            <p class="score">{{total.score | toFixed(1)}}</p>
                        </div>
                        <div class="norm_block" :style="{left: 75/200*692 + 'px', width: (125-75)/200*692 + 'px' }" :title="75 + '~' + 125"></div>
                    </div>
                </div>
                <div class="result_box">
                    <div class="you">
                        <p class="title">优&ensp;势&ensp;项</p>
                        <p class="detailBox"><span v-for="(item,index) in core.strategyAdvantage" :key="index">{{item}}</span></p>
                    </div>
                    <div class="lie">
                        <p class="title">待发展项</p>
                        <p class="detailBox"><span v-for="(item,index) in core.strategyDisadvantage" :key="index">{{item}}</span></p>
                    </div>
                </div>
            </div>
            <!--      <p class="total_score">您学习策略的水平值为<span class="score">{{total.score | toFixed(1)}}</span>，在同龄人当中<span class="grade">{{getGrade(total.score)}}</span>。</p>-->
            <div class="content_box">
                <div :class="['strategy_box', 'box'+index]" v-for="(item, index) in strategyNorms" :key="index">
                    <p class="title">{{item.name}}</p>
                    <p class="score">水平: <span :class="getColor(item.score)">{{getGrade(item.score)}}</span></p>
                </div>

                <div class="lineBox">
                    <div class="line" :class="['line'+idx]" v-for="(item, idx) in strategyNorms" :key="idx" >
                        <div class="lineLeft">
                            <div class="circle" v-if="idx==10"></div>
                        </div>
                        <div class="lineRight" :class="getBgColor(item.score)"></div>
                        <div class="circleBox">
                            <div class="circle" :class="getBgColor(item.score)"  :style="{ width: getCircleWidth(item.score) +'px',height: getCircleWidth(item.score) + 'px',marginTop: -getCircleWidth(item.score)/2 + 'px', marginLeft: -getCircleWidth(item.score)/2+ 'px'}"></div>
                        </div>
                    </div>
                </div>
                <!--          <div :class="['circle', 'circle'+idx]" v-for="(item, idx) in strategyNorms">-->
                <!--              <div class="s_circle" :style="{ width: item.score/4 + 'px',height: item.score/4 + 'px',marginTop: -item.score/5 + 'px', marginLeft: -item.score/5 + 'px'}"></div>-->
                <!--          </div>-->
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习策略分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习策略分析
            </p>
            <ThePart3Main :index="1" :normData="normData" title="认知策略-" name="复述策略" :normObj="strategyNorm[5]" :comment="strategyComment[5]" type="1"></ThePart3Main>
            <ThePart3Main :index="2" :normData="normData" title="认知策略-" name="精细加工策略" :normObj="strategyNorm[2]" :comment="strategyComment[2]" type="1"></ThePart3Main>
            <ThePart3Main :index="3" :normData="normData" title="认知策略-" name="组织策略" :normObj="strategyNorm[9]" :comment="strategyComment[9]" type="1"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习策略分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="part_small_title"></p>
            <ThePart3Main :index="4" :normData="normData" title="认知策略-" name="反馈策略" :normObj="strategyNorm[4]" :comment="strategyComment[4]" type="1"></ThePart3Main>
            <ThePart3Main :index="5" :normData="normData" title="元认知策略-" name="计划策略" :normObj="strategyNorm[0]" :comment="strategyComment[0]" type="2"></ThePart3Main>
            <ThePart3Main :index="6" :normData="normData" title="元认知策略-" name="监控策略" :normObj="strategyNorm[10]" :comment="strategyComment[10]" type="2"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习策略分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="part_small_title"></p>
            <ThePart3Main :index="7" :normData="normData" title="元认知策略-" name="调节策略" :normObj="strategyNorm[6]" :comment="strategyComment[6]" type="2"></ThePart3Main>
            <ThePart3Main :index="8" :normData="normData" title="资源管理策略-" name="时间管理策略" :normObj="strategyNorm[7]" :comment="strategyComment[7]" type="3"></ThePart3Main>
            <ThePart3Main :index="9" :normData="normData" title="资源管理策略-" name="环境管理策略" :normObj="strategyNorm[1]" :comment="strategyComment[1]" type="3"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习策略分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="part_small_title"></p>
            <ThePart3Main :index="10" :normData="normData" title="资源管理策略-" name="心境管理策略" :normObj="strategyNorm[3]" :comment="strategyComment[3]" type="3"></ThePart3Main>
            <ThePart3Main :index="11" :normData="normData" title="资源管理策略-" name="求助策略" :normObj="strategyNorm[8]" :comment="strategyComment[8]" type="3"></ThePart3Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习风格评估结果'" :headerLogo="headerLogo"></TopHeader>
            <h6 class="page_title_2">
                <span>学习风格</span>
                <span class="arrow"></span>
            </h6>
            <div class="header_detail_box">
                <!-- <p class="header_detail">学习风格指的是在学习时所习惯的方式，主要由对待信息的主动性程度、信息加工方式和信息加工速度三部分构成。学习风格具有个人特色，没有高低之分，不同风格各有优势。</p> -->
                <p class="header_detail">学习风格指的是在学习时所习惯的方式，主要由依存风格、决策风格和执行风格三部分构成。学习风格具有个人特色，没有高低之分，不同风格各有优势。</p>
            </div>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习风格评估结果
            </p>
            <div class="header_detail_box">
                <p class="header_detail">在下表中学习风格类型是测试个体在各项学习风格指标中的类型偏向，测试者的类型分布在哪边说明其学习风格偏向于哪个方向。</p>
            </div>
            <div class="table_box">
                <table>
                    <tbody>
                    <tr>
                        <th class="th_1">依<br/>存<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">依存风格类型</p>
                            <p class="detail">{{comment2.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">依存风格偏向</p>
                            <div class="score_line_box">
                                <p class="score"  :class="getScore(styleNorm2.score)" >{{comment2.name}}</p>
                                <p class="td_p1">依存型</p>
                                <p class="td_p2">依存·独立型</p>
                                <p class="td_p3">独立型</p>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="th_2">决<br/>策<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">决策风格类型</p>
                            <p class="detail">{{comment3.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">决策风格偏向</p>
                            <div class="score_line_box">
                                <p class="score"  :class="getScore(styleNorm3.score)">{{comment3.name}}</p>
                                <p class="td_p1">冲动型</p>
                                <p class="td_p2">冲动·沉思型</p>
                                <p class="td_p3">沉思型</p>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th class="th_3">执<br/>行<br/>风<br/>格</th>
                        <td class="titleBox">
                            <p class="title">执行风格类型</p>
                            <p class="detail">{{comment1.name}}</p>
                        </td>
                        <td class="td_score_box">
                            <p class="title">执行风格偏向</p>
                            <div class="score_line_box">
                                <p class="score"  :class="getScore(styleNorm1.score)">{{comment1.name}}</p>
                                <p class="td_p1">执行型</p>
                                <p class="td_p2">执行·创造型</p>
                                <p class="td_p3">创造型</p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main">
            <TopHeader :title="'学习风格分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习风格分析
            </p>
            <!--<p class="part_small_title part_small_title_num">{{partIndex}}.2.2 学习风格分析</p>-->
            <div class="main_box">
                <P class="main_title">你的依存风格属于：{{comment2.name}}</P>
                <div class="score_line_box">
                    <p class="score" :class="getScore(styleNorm2.score)" >{{comment2.name}}</p>
                    <p class="td_p1">依存型</p>
                    <p class="td_p2">依存-独立型</p>
                    <p class="td_p3">独立型</p>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment2.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment2.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>
            </div>
            <div class="main_box">
                <P class="main_title">你的决策风格属于：{{comment3.name}}</P>
                <div class="score_line_box">
                    <p class="score" :class="getScore(styleNorm3.score)" >{{comment3.name}}</p>
                    <p class="td_p1">冲动型</p>
                    <p class="td_p2">冲动-沉思型</p>
                    <p class="td_p3">沉思型</p>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment3.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment3.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>
            </div>
            <div class="main_box">
                <P class="main_title">你的执行风格属于：{{comment1.name}}</P>
                <div class="score_line_box">
                    <p class="score" :class="getScore(styleNorm1.score)" >{{comment1.name}}</p>
                    <p class="td_p1">执行型</p>
                    <p class="td_p2">执行·创造型</p>
                    <p class="td_p3">创造型</p>
                </div>
                <div class="advantage_box">
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_advantage.png" alt="">
                        <p>你的优势有：<span v-for="(item, index) in comment1.advantage">{{item.detail}}</span></p>
                    </div>
                    <div class="advantage">
                        <img src="~@/assets/report_imgs/icon_disadvantage.png" alt="">
                        <p>你的盲点有：<span v-for="(item, index) in comment1.disadvantage">{{item.detail}}</span></p>
                    </div>
                </div>
            </div>
            <p class="big_page_number"></p>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
import ThePart3Main from './ThePart3Main.vue';//目录
export default {

    name: 'page_part3',
    components: { TopHeader,ThePart3Main },
    props: {
        headerLogo: {},
        core: {
        },
        normData: {
        },
        strategyNorm: {
            type: Array//
            // required: true
        },
        strategyComment: {
            type: Array
            // required: true
        },
        styleNorm: {
            type: Object//
            // required: true
        },
        styleComment: {
            type: Object
            // required: true
        },
        partIndex: {
            type: Number
        }
    },
    data() {
        return {
            // comment: null,
            // norm: []
        }
    },
    computed: {
        total() {
            return this.strategyNorm[12];
        },
        strategyNorms() {
            return this.strategyNorm.slice(0,11);
        },
        styleNorm1() {
            return this.styleNorm.chuangxin;
        },
        styleNorm2() {
            return this.styleNorm.duli;
        },
        styleNorm3() {
            return this.styleNorm.chensi;
        },
        comment1() {
            return this.styleComment.chuangxin;
        },
        comment2() {
            return this.styleComment.duli;
        },
        comment3() {
            return this.styleComment.chensi;
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        getGrade(value) {
            if(value < 75) {
                return '低';
            }else if(value < 92) {
                return '较低';
            }else if(value < 108) {
                return '中等';
            }else if(value < 125) {
                return '较高';
            }else {
                return '高';
            }
        },
        getColor(value) {
            if(value < 75) {
                return 'color1';
            }else if(value < 92) {
                return 'color2';
            }else if(value < 108) {
                return 'color3';
            }else if(value < 125) {
                return 'color4';
            }else {
                return 'color5';
            }
        },
        getBgColor(value) {
            if(value < 75) {
                return 'bg_color1';
            }else if(value < 92) {
                return 'bg_color2';
            }else if(value < 108) {
                return 'bg_color3';
            }else if(value < 125) {
                return 'bg_color4';
            }else {
                return 'bg_color5';
            }
        },
        getCircleWidth(value) {
            if(value < 75) {
                return 5;
            }else if(value < 92) {
                return 10;
            }else if(value < 108) {
                return 15;
            }else if(value < 125) {
                return 20;
            }else {
                return 25;
            }
        },


        getScore(value) {
            // 83.125,116.875
            if(value < 83.125) {
                return 'score1'
            }else if (value < 116.875) {
                return 'score2'
            }else {
                return 'score3'
            }
        }
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_part3 {
    .content_box {
        position: relative;
        width: 100%;
        height: 500px;
        background: url(~@/assets/report2_imgs/icon_xuexicelue.png) no-repeat center center;
        position: relative;
        .lineBox {
            position: absolute;
            height: 1px;
            width: 100%;
            left: 0;
            top: 250px;
            //background-color: red;
            .line {
                position: absolute;
                height: 1px;
                display: flex;
                left: 50%;
                top: 0;
                .lineLeft {
                    height: 1px;
                    width: 50%;
                    position: relative;
                    .circle {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        right: -10px;
                        top: -10px;
                        z-index: 10;
                        background-color: #1CA4B6;
                    }
                }
                .lineRight {
                    height: 1px;
                    width: 50%;

                }
                .circleBox {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 1px;
                    height: 1px;
                    .circle {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        //position: absolute;
                        //left: -5px;
                        //top: -5px;
                        //background-color: red;
                    }
                }
            }
            .line0 {
                width: 490px;
                margin-left: -245px;
                transform: rotate(142deg);
            }
            .line1 {
                width: 500px;
                margin-left: -250px;
                transform: rotate(-6deg);
            }
            .line2 {
                width: 582px;
                margin-left: -291px;
                transform: rotate(-147deg);
            }
            .line3 {
                width: 394px;
                margin-left: -197px;
                transform: rotate(-23deg);
            }
            .line4 {
                width: 450px;
                margin-left: -225px;
                transform: rotate(162deg);
            }
            .line5 {
                width: 350px;
                margin-left: -175px;
                transform: rotate(-113deg);
            }
            .line6 {
                width: 265px;
                margin-left: -132.5px;
                transform: rotate(65deg);
            }
            .line7 {
                width: 410px;
                margin-left: -205px;
                transform: rotate(18deg);
            }
            .line8 {
                width: 400px;
                margin-left: -200px;
                transform: rotate(-43deg);
            }
            .line9 {
                width: 510px;
                margin-left: -250px;
                transform: rotate(-174deg);
            }
            .line10 {
                width: 350px;
                margin-left: -175px;
                transform: rotate(-257deg);
            }
        }
        .strategy_box {
            line-height: 26px;
            font-size: 14px;
            position: absolute;
            .title {
                font-weight: bold;
            }
        }
        .box5 {
            left: 220px;
            top: 20px;
        }
        .box2 {
            left: 10px;
            top: 53px;
        }
        .box9 {
            left: 20px;
            top: 192px;
        }
        .box4 {
            left: 50px;
            top: 310px;
        }

        .box0 {
            left: 90px;
            top: 425px;
        }

        .box10 {
            left: 285px;
            bottom: 10px;
        }

        .box6 {
            left: 408px;
            bottom: 56px;
        }


        .box7 {
            right: 40px;
            bottom: 150px;
        }

        .box1 {
            right: -20px;
            bottom: 250px;
        }

        .box3 {
            right: 50px;
            bottom: 316px;
        }

        .box8 {
            right: 116px;
            top: 60px;
        }

    }
    .total_score {
        color: #8a8a8a;
        span {
            font-weight: bold;
        }
        .score {
            color: #DE6400;
        }
        .grade {
            color: #E66971;
        }
    }
    .score_text {
        padding: 0 15px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
    }
    .score_line_box {
        margin-top: 55px;
        display: flex;
        height: 20px;
        line-height: 20px;
        width: 480px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        position: relative;
        .score {
            //[83.125,116.875]
            position: absolute;
            top: -36px;
            margin-left: -40px;
            width: 80px;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            background-color: #FFB91A;
            color: #333;
            border-radius: 3px;
            &:before {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                margin-left: -5px;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 10px solid #FFB91A;
            }
        }
        .score1 {
            left: 80px;
            background-color: #AACF00;
            &:before {
                border-top: 10px solid #AACF00;
            }
        }
        .score2 {
            left: 240px;
            background-color: #F6A724;
            &:before {
                border-top: 10px solid #F6A724;
            }
        }
        .score3 {
            left: 400px;
            background-color: #2CABBB;
            &:before {
                border-top: 10px solid #2CABBB;
            }
        }


        .td_p1 {
            //83.125/200*480
            flex: 1;
            background-color: #AACF00;
            border-radius: 10px 0 0 10px;
        }
        .td_p2 {
            flex: 1;
            background-color: #F6A724;
        }
        .td_p3 {
            flex: 1;
            background-color: #2CABBB;
            border-radius: 0 10px 10px 0;
        }
    }
    .table_box {
        padding-bottom: 60px;
        color: #333;
        tr {
            .c_line {
                background-color: #41CBAA;
            }
            .c_linec {
                background-color: #F08C00;
            }
            .c_line {
                background-color: #E7A53C;
            }
            th {
                color: #fff;
                font-size: 16px;
                background-color: #41CBAA;
                border: 1px solid #fff;
                width: 36px;
                height: 137px;
                text-align: center;
                border-radius: 6px;
            }
            .th_1 {
                background-color: #1CA4B6;
            }
            .th_2 {
                background-color: #AACF00;
            }
            .th_3 {
                background-color: #F6A724;
            }
            td {
                font-size: 14px;
                height: 84px;
                text-align: center;
                background-color: #F7F7F7;
                border: 1px solid #fff;
                .title {
                    margin-bottom: 10px;
                }
                .detail {
                    color: #F6A724;
                    font-size: 18px;
                    font-weight: bold;
                    padding-bottom: 30px;
                }

            }
            .titleBox {
                padding-left: 26px;
                text-align: left;
            }
            .td_score_box{
                width: 480px;
                padding: 0 20px;
                padding-bottom: 20px;
                .title {
                    text-align: left;
                    margin-bottom: 50px;
                }
            }
        }
    }
    .main_score_box {
        width: 340px;
        margin-top: -20px;
    }
    .advantage_box {
        padding-top: 40px;
        padding-bottom: 2px;
        .advantage {
            display: flex;
            height: 56px;
            align-items: center;
            line-height: 28px;
            margin-bottom: 35px;
            p {
                font-weight: bold;
                span {
                    font-weight: normal;
                    color: #8a8a8a;
                }
            }
            img {
                margin-right: 15px;
            }
        }
    }

}
</style>
